import { render, staticRenderFns } from "./lainahaku.vue?vue&type=template&id=632fd81c&"
import script from "./lainahaku.vue?vue&type=script&lang=js&"
export * from "./lainahaku.vue?vue&type=script&lang=js&"
import style0 from "./lainahaku.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports